import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BookMarked } from "lucide-react";
import KundliPanel from "@/components/KundliPanel";

export default function Kundli() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const recordId = params.get("id");
  return (
    <div className="space-y-6" data-testid="kundli-page">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-amber-600 dark:text-amber-400">Vedic Chart</div>
          <h1 className="font-display text-3xl md:text-4xl font-light tracking-tight mt-1">Kundli Generator</h1>
          <p className="text-sm text-slate-500 mt-1">Enter birth details to produce a Vedic (sidereal) chart with planetary placements, dashas, and a generic AI-drafted reading.</p>
        </div>
        <Button variant="outline" onClick={() => nav("/kundli/saved")} data-testid="saved-kundlis-link"><BookMarked className="w-4 h-4 mr-1.5" /> Saved Kundlis</Button>
      </div>
      <KundliPanel key={recordId || "new"} recordId={recordId} />
    </div>
  );
}
